import React from 'react';

import MenuEditorSidepanel from 'modules/menu/components/MenuEditorSidepanel';
import { ItemQuantity } from 'modules/menu/items/types';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { EditOffer } from './EditOffer';
import { useSelectionData } from '../../../hooks/useSelectionData';
import { OfferOverridesProvider } from '../context/OfferOverridesContext';
import { OfferTabProvider } from '../context/OfferTabContext';
import { ProductOverridesProvider } from '../context/ProductOverridesContext';
import { Offer } from '../types';
import { getOfferCategory } from '../utils';

type EditOfferSidePanelProps = {
  offer: Offer;
  onClose: () => void;
  offerQuantity?: ItemQuantity;
  refetchOfferInventory: () => void;
};

export const EditOfferSidePanel = ({
  offer,
  onClose,
  offerQuantity,
  refetchOfferInventory,
}: EditOfferSidePanelProps) => {
  const { categories } = useSelectionData();
  const menuPermissions = useOfferingMenuPermissionsContext();

  const categoryId = getOfferCategory(categories, offer.id)?.id ?? null;

  return (
    <MenuEditorSidepanel id={offer.id} title={offer.name[0].value} onClose={onClose}>
      {menuPermissions.contentEdit ? (
        ({ editing, setEditing }) => (
          <OfferTabProvider>
            <OfferOverridesProvider offer={offer} key={offer.id}>
              <ProductOverridesProvider offer={offer} key={offer.id}>
                <EditOffer
                  offer={offer}
                  categoryId={categoryId}
                  onClose={onClose}
                  isEditing={editing}
                  setIsEditing={setEditing}
                  offerQuantity={offerQuantity}
                  refetchOfferInventory={refetchOfferInventory}
                />
              </ProductOverridesProvider>
            </OfferOverridesProvider>
          </OfferTabProvider>
        )
      ) : (
        <OfferTabProvider>
          <OfferOverridesProvider offer={offer} key={offer.id}>
            <ProductOverridesProvider offer={offer}>
              <EditOffer
                offer={offer}
                categoryId={categoryId}
                onClose={onClose}
                isEditing={false}
                setIsEditing={() => ({})}
                offerQuantity={offerQuantity}
                refetchOfferInventory={refetchOfferInventory}
              />
            </ProductOverridesProvider>
          </OfferOverridesProvider>
        </OfferTabProvider>
      )}
    </MenuEditorSidepanel>
  );
};
